module.exports = __webpack_public_path__ + "static/img/quanmianshidai.a7bb95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/quanmianshidai.png
// module id = WhBG
// module chunks = 34